var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"track"},[_c('div',{class:['track__header', { 'track__header--scroll': _vm.scrolled }]},[_vm._t("header")],2),_c('div',{class:['track__content', {
    'track__content--empty': _vm.isContentEmpty,
    'track__content--has-footer': _vm.hasFooterSlot,
    }]},[_c('div',{on:{"scroll":_vm.handleScroll}},[_vm._t("content"),_vm._t("contentEmpty",function(){return [(_vm.isContentEmpty)?_c('span',[_vm._v(" "+_vm._s(_vm.emptyContent)+" ")]):_vm._e()]})],2)]),_c('div',{staticClass:"track__footer"},[_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }